import { render, staticRenderFns } from "./AgentsList.vue?vue&type=template&id=4dfa9990"
import script from "./AgentsList.vue?vue&type=script&lang=js"
export * from "./AgentsList.vue?vue&type=script&lang=js"
import style0 from "./AgentsList.vue?vue&type=style&index=0&id=4dfa9990&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports